import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentResultPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const collectionStatus = params.get('collection_status') || params.get('status') || '';
  const externalRef = params.get('external_reference') || '';

  let type = 'pending';
  if (location.pathname.includes('success') || collectionStatus === 'approved') type = 'success';
  else if (location.pathname.includes('failure') || collectionStatus === 'rejected') type = 'failure';

  const config = {
    success: {
      icon: <CheckCircle2 className="w-12 h-12 text-emerald-400" />,
      ringColor: 'border-emerald-500/30 bg-emerald-500/10',
      title: '¡Pago aprobado!',
      titleColor: 'text-emerald-400',
      desc: 'Tu pedido fue confirmado y ya está en preparación.',
    },
    pending: {
      icon: <Clock className="w-12 h-12 text-amber-400" />,
      ringColor: 'border-amber-500/30 bg-amber-500/10',
      title: 'Pago pendiente',
      titleColor: 'text-amber-400',
      desc: 'Completa tu pago según las instrucciones de Mercado Pago. Te avisaremos cuando se confirme.',
    },
    failure: {
      icon: <XCircle className="w-12 h-12 text-rose-400" />,
      ringColor: 'border-rose-500/30 bg-rose-500/10',
      title: 'Pago rechazado',
      titleColor: 'text-rose-400',
      desc: 'Tu pago no fue procesado. Puedes intentarlo de nuevo con otro método.',
    },
  }[type];

  return (
    <div className="max-w-lg mx-auto px-4 mt-20 pb-32 text-center">
      <div className={`mx-auto w-24 h-24 rounded-full border flex items-center justify-center ${config.ringColor}`}>
        {config.icon}
      </div>
      <h1 className={`mt-6 text-3xl font-black ${config.titleColor}`}>{config.title}</h1>
      <p className="mt-3 text-white/60 text-base leading-relaxed">{config.desc}</p>
      {externalRef && (
        <p className="mt-3 text-white/40 text-sm">
          Pedido: <span className="text-orange-400 font-bold">{externalRef}</span>
        </p>
      )}
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          onClick={() => navigate('/pedidos')}
          className="bg-orange-500 hover:bg-orange-600 text-black font-black"
          data-testid="payment-result-orders-btn"
        >
          Ver mis pedidos
        </Button>
        {type === 'failure' && (
          <Button
            onClick={() => navigate('/carrito')}
            variant="outline"
            className="border-white/20 text-white hover:bg-white/10"
            data-testid="payment-result-retry-btn"
          >
            Volver al carrito
          </Button>
        )}
        <Button
          onClick={() => navigate('/catalogo')}
          variant="outline"
          className="border-white/20 text-white hover:bg-white/10"
          data-testid="payment-result-catalog-btn"
        >
          Seguir comprando
        </Button>
      </div>
    </div>
  );
}
